<template>
	<div class="network-menu" :class="{ expanded: expanded }">
		<div class="main-logo" @click="toggleMenu()">
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				width="240.4px"
				height="79px"
				viewBox="0 0 240.4 79"
				style="overflow:visible;enable-background:new 0 0 240.4 79;"
				xml:space="preserve"
			>
				<g class="logo-text">
					<path
						d="M30.45,0.8c3.2,0.13,5.6,0.2,7.2,0.2C39.08,1,41.2,0.93,44,0.8v0.6c-1.6,0.27-2.8,0.71-3.6,1.32
		c-0.8,0.62-1.2,1.66-1.2,3.13c0,0.8,0.12,2.13,0.35,3.98c0.23,1.85,0.55,3.94,0.95,6.27c0.4,2.33,0.81,4.58,1.23,6.75
		c0.42,2.17,0.81,4.05,1.17,5.65c0.33,1.5,0.84,2.58,1.52,3.22c0.68,0.65,2.04,1.11,4.08,1.38v0.6c-3.53-0.13-6.18-0.2-7.95-0.2
		c-1.7,0-4.13,0.07-7.3,0.2H33.1v-0.6c1.77-0.27,3.07-0.67,3.92-1.22s1.27-1.59,1.27-3.13c0-1.23-0.12-2.53-0.35-3.9L34.5,4.7h-0.1
		c-0.9,2.27-2.3,5.62-4.2,10.05c-1.77,4.1-3.21,7.54-4.33,10.33c-1.12,2.78-2.11,5.59-2.98,8.42h-0.1c-1.4-4.67-3.07-9.33-5.02-14
		c-1.95-4.67-4.24-9.77-6.88-15.3h-0.1c-0.23,1.67-0.5,3.67-0.8,6s-0.55,4.54-0.75,6.63s-0.37,4.01-0.5,5.77
		c-0.13,1.77-0.2,3.08-0.2,3.95c0,2.33,0.39,3.98,1.18,4.95c0.78,0.97,2.32,1.5,4.63,1.6v0.6H14.2c-3.5-0.13-6.18-0.2-8.05-0.2
		c-1.37,0-3.42,0.07-6.15,0.2v-0.6c1.5-0.1,2.84-0.52,4.02-1.27C5.21,31.08,5.9,30.1,6.1,28.9c0.2-1.1,0.43-2.75,0.7-4.95
		c0.1-0.77,0.22-1.62,0.35-2.55l2.4-17.8C8.88,3.07,8.08,2.62,7.13,2.25C6.17,1.88,5.18,1.6,4.15,1.4V0.8C7.95,0.93,10.8,1,12.7,1
		c1.37,0,3.42-0.07,6.15-0.2v0.6c-0.73,0.17-1.34,0.46-1.83,0.88c-0.48,0.42-0.73,1.01-0.73,1.77c0,0.73,0.28,1.78,0.85,3.15
		l0.05,0.15l7.05,17.3C28.12,16.68,31.13,9.5,33.3,3.1c-0.63-0.7-1.58-1.27-2.85-1.7V0.8z"
					/>
					<path
						d="M59.65,31.55c0.67,0.17,1.55,0.32,2.65,0.45c1.1,0.13,2.07,0.2,2.9,0.2c2.03,0,3.83-0.17,5.4-0.5
		c1.57-0.33,3-0.86,4.3-1.58s2.53-1.64,3.7-2.78c1.17-1.13,2.37-2.52,3.6-4.15l0.55,0.45L78.2,33.7c-1.53-0.13-2.7-0.2-3.5-0.2H55.9
		c-1.3,0-3.18,0.07-5.65,0.2H50.1v-0.6c1.2-0.1,2.13-0.29,2.8-0.57c0.67-0.28,1.17-0.69,1.5-1.23c0.33-0.53,0.54-1.22,0.63-2.08
		c0.08-0.85,0.13-2.06,0.13-3.63V8.9c0-1.6-0.05-2.82-0.15-3.65c-0.1-0.83-0.31-1.53-0.63-2.08c-0.32-0.55-0.82-0.96-1.5-1.22
		C52.19,1.68,51.23,1.5,50,1.4V0.8l1.85,0.05c1.8,0.03,3.69,0.07,5.67,0.1C59.51,0.98,61.65,1,63.95,1c3.2,0,7.85-0.07,13.95-0.2
		h0.15c-0.07,1.03-0.1,2.42-0.1,4.15c0,0.57,0.05,1.47,0.15,2.7c0.07,0.93,0.12,1.6,0.15,2l-0.65,0.2c-0.4-1.57-0.96-2.86-1.68-3.88
		c-0.72-1.02-1.54-1.81-2.48-2.38c-0.93-0.57-1.96-0.96-3.07-1.17c-1.12-0.22-2.36-0.33-3.73-0.33c-2.3,0-4.63,0.1-7,0.3v12.5
		c0.43,0,1.08-0.02,1.95-0.05c0.83-0.03,1.47-0.05,1.9-0.05c2.4,0,4.25-0.48,5.55-1.45c1.3-0.97,2.1-2.62,2.4-4.95h0.6
		c0,0.8-0.02,2-0.05,3.6c-0.03,1.6-0.05,2.78-0.05,3.55c0,0.8,0.02,2,0.05,3.6c0.03,1.6,0.05,2.8,0.05,3.6h-0.6
		c-0.3-1.4-0.66-2.54-1.07-3.42c-0.42-0.88-0.96-1.56-1.63-2.03c-0.67-0.47-1.47-0.78-2.4-0.95c-0.93-0.17-2.1-0.25-3.5-0.25h-3.2
		V31.55z"
					/>
					<path
						d="M93.8,25.6c0,1.57,0.05,2.78,0.15,3.63c0.1,0.85,0.32,1.54,0.65,2.08c0.33,0.53,0.85,0.94,1.55,1.23s1.67,0.47,2.9,0.57
		v0.6H98.9c-3.23-0.13-5.72-0.2-7.45-0.2c-1.63,0-4.05,0.07-7.25,0.2v-0.6c1.2-0.1,2.14-0.29,2.83-0.57
		c0.68-0.28,1.18-0.69,1.5-1.23c0.32-0.53,0.52-1.22,0.63-2.08c0.1-0.85,0.15-2.06,0.15-3.63V8.9c0-1.6-0.05-2.82-0.15-3.65
		c-0.1-0.83-0.32-1.53-0.65-2.08c-0.33-0.55-0.84-0.96-1.52-1.22C86.29,1.68,85.33,1.5,84.1,1.4V0.8C87.7,0.93,90.42,1,92.25,1
		c1.5,0,3.68-0.07,6.55-0.2v0.6c-1.2,0.1-2.13,0.28-2.77,0.55s-1.13,0.67-1.45,1.22c-0.32,0.55-0.52,1.25-0.63,2.1
		c-0.1,0.85-0.15,2.06-0.15,3.63v8.45l7.6-6.2c1.47-1.2,2.71-2.45,3.73-3.75c1.02-1.3,1.52-2.38,1.52-3.25
		c0-0.93-0.36-1.62-1.08-2.05C104.86,1.67,104,1.43,103,1.4V0.8h0.15c3.17,0.13,5.6,0.2,7.3,0.2c1.77,0,4.42-0.07,7.95-0.2v0.6
		c-0.87,0.1-1.67,0.27-2.42,0.5s-1.51,0.57-2.28,1.02c-0.77,0.45-1.57,1-2.42,1.65c-0.85,0.65-1.91,1.51-3.17,2.58l-6.2,5.3
		L112,27.3c1.13,1.63,2.38,2.98,3.73,4.05c1.35,1.07,2.82,1.65,4.42,1.75v0.6c-3.8-0.13-6.67-0.2-8.6-0.2c-1.77,0-4.3,0.07-7.6,0.2
		h-0.15v-0.6c1.37-0.1,2.45-0.38,3.25-0.82c0.8-0.45,1.2-1.19,1.2-2.23c0-0.37-0.1-0.72-0.3-1.08c-0.2-0.35-0.57-0.91-1.1-1.67
		c-0.37-0.53-0.6-0.87-0.7-1L98.6,15.2l-4.8,3.75V25.6z"
					/>
					<path
						d="M123.22,10.1c0.95-2.13,2.28-3.96,3.97-5.47c1.7-1.52,3.68-2.67,5.93-3.45C135.38,0.39,137.77,0,140.3,0
		c2.53,0,4.92,0.39,7.17,1.17c2.25,0.78,4.22,1.93,5.93,3.45c1.7,1.52,3.02,3.34,3.97,5.47c0.95,2.13,1.42,4.52,1.42,7.15
		c0,2.6-0.48,4.97-1.42,7.13c-0.95,2.15-2.28,3.98-3.97,5.5c-1.7,1.52-3.68,2.67-5.93,3.45c-2.25,0.78-4.64,1.17-7.17,1.17
		c-2.53,0-4.92-0.39-7.17-1.17c-2.25-0.78-4.22-1.93-5.93-3.45c-1.7-1.52-3.02-3.35-3.97-5.5c-0.95-2.15-1.42-4.53-1.42-7.13
		C121.8,14.62,122.28,12.23,123.22,10.1z M128,23.1c0.6,1.87,1.47,3.53,2.63,4.98s2.55,2.58,4.2,3.4c1.65,0.82,3.48,1.23,5.48,1.23
		s3.83-0.41,5.48-1.23c1.65-0.82,3.05-1.95,4.2-3.4s2.03-3.11,2.63-4.98c0.6-1.87,0.9-3.82,0.9-5.85s-0.3-3.98-0.9-5.85
		s-1.47-3.53-2.63-4.98s-2.55-2.58-4.2-3.4c-1.65-0.82-3.48-1.23-5.48-1.23s-3.83,0.41-5.48,1.23c-1.65,0.82-3.05,1.95-4.2,3.4
		S128.6,9.53,128,11.4s-0.9,3.82-0.9,5.85S127.4,21.23,128,23.1z"
					/>
					<path
						d="M161.9,0.8l0.9,0.05c0.97,0.03,1.96,0.07,2.97,0.1C166.79,0.98,167.83,1,168.9,1c0.9,0,2.28-0.07,4.15-0.2h0.15
		c0.57,0.73,1.46,1.85,2.67,3.35c1.22,1.5,2.89,3.53,5.02,6.1c1.6,1.97,2.96,3.63,4.08,5c1.12,1.37,2.29,2.81,3.52,4.33
		s2.27,2.82,3.13,3.9c0.85,1.08,1.52,1.98,2.02,2.68h0.1c0-0.33,0.02-1.33,0.05-3c0-1.63,0-2.62,0-2.95v-5.8
		c0-4.6-0.41-7.87-1.22-9.8c-0.82-1.93-2.49-3-5.03-3.2V0.8c3.13,0.13,5.48,0.2,7.05,0.2c1.47,0,3.63-0.07,6.5-0.2v0.6
		c-2.1,0.3-3.54,0.9-4.33,1.8c-0.78,0.9-1.17,2.37-1.17,4.4v26.5h-1.85c-1.7-2.7-3.56-5.39-5.58-8.07
		c-2.02-2.68-4.03-5.23-6.03-7.63c-2-2.4-3.85-4.54-5.55-6.43c-1.7-1.88-3.6-3.97-5.7-6.27c-0.07,2.27-0.1,3.97-0.1,5.1v8.75
		c0,3.23,0.07,5.65,0.2,7.25c0.13,1.6,0.41,2.83,0.83,3.7c0.42,0.87,1.05,1.47,1.9,1.83c0.85,0.35,2.11,0.61,3.77,0.77v0.6
		c-4.4-0.13-7.7-0.2-9.9-0.2c-1.27,0-3.17,0.07-5.7,0.2v-0.6h0.05c1.43-0.2,2.51-0.38,3.22-0.52c0.72-0.15,1.34-0.4,1.88-0.75
		c0.53-0.35,0.93-0.85,1.2-1.5c0.27-0.65,0.42-1.54,0.45-2.67l0.6-22.95c-1-0.8-2.11-1.46-3.32-1.98c-1.22-0.52-2.58-0.96-4.08-1.32
		V0.8z"
					/>
					<path
						d="M234.05,11.5c-0.73-1.53-1.45-2.86-2.15-3.97c-0.7-1.12-1.52-2.13-2.45-3.05c-0.93-0.92-2.02-1.64-3.25-2.17
		c-1.23-0.53-2.62-0.8-4.15-0.8c-1.83,0-3.5,0.45-5,1.35c-1.5,0.9-2.78,2.12-3.83,3.65s-1.86,3.23-2.42,5.1
		c-0.57,1.87-0.85,3.73-0.85,5.6c0,2.1,0.27,4.09,0.82,5.97c0.55,1.88,1.36,3.54,2.43,4.98c1.07,1.43,2.35,2.55,3.85,3.35
		s3.17,1.2,5,1.2c1.77,0,3.4-0.17,4.9-0.53c1.5-0.35,2.87-0.97,4.1-1.88v-6.45c0-2.27-1.72-3.45-5.15-3.55v-0.6
		c0.27,0,0.7,0.02,1.3,0.05c1.37,0.07,2.45,0.11,3.25,0.13c0.8,0.02,1.65,0.03,2.55,0.03c1.67,0,4.13-0.07,7.4-0.2v0.6
		c-1.6,0.1-2.81,0.44-3.63,1.03s-1.22,1.61-1.22,3.08v7c-3,1.03-5.51,1.81-7.53,2.32c-2.02,0.52-3.96,0.78-5.82,0.78
		c-2.23,0-4.43-0.38-6.58-1.15c-2.15-0.77-4.07-1.89-5.77-3.38c-1.7-1.48-3.04-3.3-4.02-5.45c-0.98-2.15-1.48-4.58-1.48-7.28
		c0-2.37,0.5-4.61,1.5-6.72s2.36-3.97,4.08-5.55c1.72-1.58,3.64-2.81,5.78-3.67c2.13-0.87,4.3-1.3,6.5-1.3
		c2.17,0,4.02,0.13,5.55,0.4s3.17,0.65,4.9,1.15c0.07,0,0.33,0.07,0.8,0.2c0,0.5,0.04,1.15,0.13,1.95c0.08,0.8,0.2,1.74,0.35,2.83
		s0.39,2.74,0.72,4.97H234.05z"
					/>
				</g>
				<g class="logo-text">
					<path
						d="M7.58,74c0.55,0.53,0.82,1.2,0.82,2c0,0.77-0.27,1.42-0.82,1.97C7.02,78.53,6.37,78.8,5.6,78.8
		c-0.77,0-1.43-0.27-1.98-0.83C3.08,77.42,2.8,76.77,2.8,76c0-0.8,0.28-1.47,0.83-2s1.21-0.8,1.98-0.8C6.37,73.2,7.02,73.47,7.58,74
		z"
					/>
					<path
						d="M21.3,78.1c1.2-0.1,2.14-0.29,2.83-0.57c0.68-0.28,1.18-0.69,1.5-1.23c0.32-0.53,0.52-1.22,0.63-2.08
		c0.1-0.85,0.15-2.06,0.15-3.63V47.4c-1.93,0-3.47,0.07-4.6,0.22c-1.13,0.15-2.12,0.49-2.95,1.03c-0.83,0.53-1.58,1.36-2.23,2.47
		c-0.65,1.12-1.29,2.67-1.92,4.67l-0.65-0.2l0.7-9.8c3.67,0.13,6.43,0.2,8.3,0.2H34.8c1.8,0,4.38-0.07,7.75-0.2h0.15l0.7,9.8
		l-0.65,0.2c-0.63-2-1.27-3.56-1.92-4.67c-0.65-1.12-1.39-1.94-2.23-2.47c-0.83-0.53-1.83-0.88-2.98-1.03S32.9,47.4,30.9,47.4v23.2
		c0,1.57,0.05,2.78,0.15,3.63c0.1,0.85,0.32,1.54,0.65,2.08c0.33,0.53,0.85,0.94,1.55,1.23s1.67,0.47,2.9,0.57v0.6H36
		c-3.23-0.13-5.72-0.2-7.45-0.2c-1.63,0-4.05,0.07-7.25,0.2V78.1z"
					/>
					<path
						d="M81.8,78.5h-9c-2.23-2.47-4.24-4.91-6.02-7.33c-1.78-2.42-3.31-4.89-4.58-7.42c-0.67,0-1.63-0.1-2.88-0.3
		s-2.21-0.42-2.88-0.65v7.8c0,1.57,0.05,2.78,0.15,3.63c0.1,0.85,0.32,1.54,0.65,2.08c0.33,0.53,0.85,0.94,1.55,1.23
		c0.7,0.28,1.67,0.47,2.9,0.57v0.6h-0.15c-3.23-0.13-5.72-0.2-7.45-0.2c-1.63,0-4.05,0.07-7.25,0.2v-0.6
		c1.2-0.1,2.14-0.29,2.82-0.57c0.68-0.28,1.18-0.69,1.5-1.23c0.32-0.53,0.52-1.22,0.63-2.08c0.1-0.85,0.15-2.06,0.15-3.63V53.9
		c0-1.6-0.05-2.83-0.15-3.68c-0.1-0.85-0.31-1.54-0.63-2.07c-0.32-0.53-0.82-0.93-1.5-1.2c-0.68-0.27-1.63-0.45-2.82-0.55v-0.6H47
		c2.73,0.13,4.82,0.2,6.25,0.2c0.57,0,1.77-0.07,3.6-0.2c0.87-0.1,1.74-0.17,2.63-0.22c0.88-0.05,1.64-0.08,2.27-0.08
		c1.53,0,3.03,0.19,4.5,0.58c1.47,0.38,2.81,0.97,4.02,1.77c1.22,0.8,2.19,1.83,2.92,3.08c0.73,1.25,1.1,2.69,1.1,4.33
		c0,2.17-0.72,3.93-2.15,5.3c-1.43,1.37-3.3,2.28-5.6,2.75c0.87,1.47,1.83,2.97,2.9,4.5c1.07,1.53,2.27,3.04,3.6,4.53
		c1.33,1.48,2.75,2.74,4.25,3.77c1.5,1.03,3,1.63,4.5,1.8V78.5z M56.45,61.1c1.63,0.57,3.18,0.85,4.65,0.85
		c2.67,0,4.7-0.62,6.1-1.85c1.4-1.23,2.1-3.17,2.1-5.8c0-2.13-0.77-3.88-2.3-5.25C65.47,47.68,63.62,47,61.45,47
		c-1.97,0-3.57,0.18-4.8,0.55c-0.07,2.13-0.12,3.89-0.15,5.28c-0.03,1.38-0.05,3.01-0.05,4.88V61.1z"
					/>
					<path
						d="M91.9,64.05l-3.3,9.05l-0.1,0.25c-0.2,0.47-0.3,0.83-0.3,1.1c0,0.57,0.17,1.07,0.5,1.5c0.33,0.43,0.75,0.8,1.25,1.1
		s1.02,0.53,1.55,0.7c0.53,0.17,1,0.28,1.4,0.35v0.6c-2.67-0.13-4.68-0.2-6.05-0.2c-1.17,0-2.87,0.05-5.1,0.15L80.9,78.7v-0.6
		c1.73-0.37,3-1.08,3.8-2.15c0.8-1.07,1.62-2.6,2.45-4.6l0.3-0.75l8.65-21.25c0.03-0.03,0.05-0.08,0.05-0.15
		c0.23-0.5,0.35-0.85,0.35-1.05c0-0.17-0.06-0.41-0.17-0.73c-0.12-0.32-0.26-0.63-0.43-0.92c0.9-0.17,2.03-0.53,3.4-1.1
		c0.37-0.17,0.68-0.3,0.95-0.4l10.4,28.6c0.5,1.37,1.18,2.41,2.02,3.13c0.85,0.72,2.06,1.18,3.63,1.38v0.6h-0.15
		c-3.37-0.13-5.97-0.2-7.8-0.2c-1.37,0-2.43,0.01-3.18,0.03c-0.75,0.02-1.71,0.06-2.88,0.13l-1.2,0.05v-0.6
		c1.47-0.2,2.66-0.58,3.57-1.15c0.92-0.57,1.38-1.28,1.38-2.15c0-0.27-0.1-0.65-0.3-1.15c-0.07-0.17-0.12-0.3-0.15-0.4l-3.25-9.2
		H91.9z M97.3,49.85l-4.9,12.7h9.4L97.3,49.85z"
					/>
					<path
						d="M110.95,45.8c3.07,0.13,5.37,0.2,6.9,0.2c1.87,0,4.57-0.07,8.1-0.2v0.6h-0.05c-0.67,0.1-1.22,0.19-1.67,0.27
		c-0.45,0.08-0.9,0.23-1.35,0.45s-0.82,0.52-1.1,0.9s-0.42,0.88-0.42,1.47c0,0.67,0.48,2.17,1.45,4.5l7.85,19l6.5-15.35
		c1.67-4,2.5-6.75,2.5-8.25c0-1-0.38-1.71-1.13-2.13s-1.74-0.71-2.97-0.88v-0.6c3,0.13,5.23,0.2,6.7,0.2c1.23,0,3.05-0.07,5.45-0.2
		v0.6c-0.97,0.1-1.82,0.39-2.55,0.88c-0.73,0.48-1.37,1.07-1.9,1.77c-0.53,0.7-0.99,1.45-1.38,2.25c-0.38,0.8-0.79,1.75-1.23,2.85
		c-0.3,0.7-0.52,1.2-0.65,1.5L129.6,79h-1.1l-11.65-27.4c-0.67-1.57-1.46-2.8-2.38-3.7c-0.92-0.9-2.09-1.4-3.52-1.5V45.8z"
					/>
					<path
						d="M158.3,76.55c0.67,0.17,1.55,0.32,2.65,0.45c1.1,0.13,2.07,0.2,2.9,0.2c2.03,0,3.83-0.17,5.4-0.5
		c1.57-0.33,3-0.86,4.3-1.58s2.53-1.64,3.7-2.78c1.17-1.13,2.37-2.52,3.6-4.15l0.55,0.45l-4.55,10.05c-1.53-0.13-2.7-0.2-3.5-0.2
		h-18.8c-1.3,0-3.18,0.07-5.65,0.2h-0.15v-0.6c1.2-0.1,2.13-0.29,2.8-0.57c0.67-0.28,1.17-0.69,1.5-1.23
		c0.33-0.53,0.54-1.22,0.63-2.08c0.08-0.85,0.13-2.06,0.13-3.63V53.9c0-1.6-0.05-2.82-0.15-3.65c-0.1-0.83-0.31-1.53-0.63-2.08
		s-0.82-0.96-1.5-1.22s-1.64-0.45-2.88-0.55v-0.6l1.85,0.05c1.8,0.03,3.69,0.07,5.67,0.1c1.98,0.03,4.13,0.05,6.42,0.05
		c3.2,0,7.85-0.07,13.95-0.2h0.15c-0.07,1.03-0.1,2.42-0.1,4.15c0,0.57,0.05,1.47,0.15,2.7c0.07,0.93,0.12,1.6,0.15,2l-0.65,0.2
		c-0.4-1.57-0.96-2.86-1.67-3.88c-0.72-1.02-1.54-1.81-2.48-2.38c-0.93-0.57-1.96-0.96-3.08-1.17c-1.12-0.22-2.36-0.33-3.72-0.33
		c-2.3,0-4.63,0.1-7,0.3v12.5c0.43,0,1.08-0.02,1.95-0.05c0.83-0.03,1.47-0.05,1.9-0.05c2.4,0,4.25-0.48,5.55-1.45
		c1.3-0.97,2.1-2.62,2.4-4.95h0.6c0,0.8-0.02,2-0.05,3.6s-0.05,2.78-0.05,3.55c0,0.8,0.02,2,0.05,3.6c0.03,1.6,0.05,2.8,0.05,3.6
		h-0.6c-0.3-1.4-0.66-2.54-1.08-3.42c-0.42-0.88-0.96-1.56-1.63-2.03c-0.67-0.47-1.47-0.78-2.4-0.95c-0.93-0.17-2.1-0.25-3.5-0.25
		h-3.2V76.55z"
					/>
					<path
						d="M199.1,46.4c-1.6,0.23-2.85,0.49-3.75,0.77c-0.9,0.28-1.55,0.64-1.95,1.08c-0.4,0.43-0.66,0.97-0.77,1.6
		c-0.12,0.63-0.17,1.53-0.17,2.7v24c2.23,0.43,3.97,0.65,5.2,0.65c3.73,0,6.69-0.74,8.88-2.23c2.18-1.48,4.33-3.97,6.43-7.47h0.75
		l-3.85,11.2c-3.2-0.13-5.62-0.2-7.25-0.2h-14.7c-1.13,0-2.8,0.07-5,0.2v-0.6c2.03-0.2,3.38-0.63,4.05-1.3c0.67-0.67,1-1.7,1-3.1
		V53.9c0-1.57-0.04-2.78-0.13-3.63c-0.08-0.85-0.29-1.55-0.63-2.1c-0.33-0.55-0.83-0.96-1.5-1.22c-0.67-0.27-1.6-0.45-2.8-0.55v-0.6
		h0.15c3.3,0.13,5.83,0.2,7.6,0.2c1.9,0,4.72-0.07,8.45-0.2V46.4z"
					/>
				</g>
			</svg>
		</div>
		<div class="network-popup">
			<div class="network-link" v-for="(item, index) of items" :key="index">
				<a :href="item.url" target="_blank" rel="noopener noreferrer" :title="item.title">
					<img :src="item.logo" :alt="item.title" />
				</a>
			</div>
			<div class="close-button">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="35"
					height="35"
					viewBox="0 0 35 35"
					@click="onClickClose()"
				>
					<path
						id="Path_475"
						data-name="Path 475"
						d="M196.736,39.917,211.551,25.1a1.573,1.573,0,0,0-2.224-2.225L194.512,37.692,179.7,22.877a1.573,1.573,0,0,0-2.224,2.225l14.815,14.815L177.473,54.731a1.573,1.573,0,1,0,2.224,2.225l14.815-14.815,14.815,14.815a1.573,1.573,0,0,0,2.224-2.225Z"
						transform="translate(-177.011 -22.416)"
						fill="#313131"
					/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
import experienceMekongLogo from '@/assets/images/experience-mekong-logo.png';
import mekongDealsLogo from '@/assets/images/mekong-deals-logo.png';
import mekongHeroesLogo from '@/assets/images/mekong-heroes-logo.png';
import mekongMemoriesLogo from '@/assets/images/mekong-memories-logo.png';
import mekongMomentsLogo from '@/assets/images/mekong-moments-logo.png';
import mistLogo from '@/assets/images/mist-logo.png';

export default {
	data() {
		return {
			expanded: false,
			items: [
				{
					title: 'Experience Mekong',
					url: 'http://www.experiencemekong.org/',
					logo: experienceMekongLogo,
				},
				{
					title: 'Mekong Deals',
					url: 'http://www.mekongdeals.com',
					logo: mekongDealsLogo,
				},
				{
					title: 'Mekong Heroes',
					url: 'http://mekongheroes.com/',
					logo: mekongHeroesLogo,
				},
				{
					title: 'Mekong Memories',
					url: 'http://mekongheroes.com/',
					logo: mekongMemoriesLogo,
				},
				{
					title: 'Mekong Moments',
					url: 'https://www.mekongmoments.com',
					logo: mekongMomentsLogo,
				},
				{
					title: 'MIST',
					url: 'https://mist.asia/',
					logo: mistLogo,
				},
			],
		};
	},
	methods: {
		toggleMenu() {
			this.expanded = !this.expanded;
		},
		onClickClose() {
			this.expanded = false;
		},
	},
};
</script>

<style lang="scss">
.network-menu {
	background-color: transparent;
	position: relative;
	width: 326px;
	margin-top: -1rem;

	.main-logo {
		cursor: pointer;
		text-align: center;
		padding-top: 1.5rem;

		.logo-text  {
			fill: #000;
			user-select: none;
		}
	}

	.network-popup {
		position: absolute;
		background-color: #fff;
		box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
		z-index: 2;
		text-align: center;
		padding: 30px 20px 20px;
		display: none;

		.close-button {
			margin-top: 20px;
			text-align: right;

			svg {
				width: 35px;
				cursor: pointer;
			}
		}
	}

	.network-link {
		& + .network-link {
			margin-top: 40px;
		}

		a {
			display: block;
		}
	}

	&.expanded {
		background-color: #fff;

		.network-popup {
			display: block;
		}
	}
}
</style>
